import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-home',
  templateUrl: './support-home.component.html',
  styleUrls: ['./support-home.component.scss']
})
export class SupportHomeComponent implements OnInit {
  pageTitle: string = "Support";

  constructor(@Inject(LOCALE_ID) private locale: string) {
    if (this.locale == "es") this.pageTitle = "Apoyo";
  }

  ngOnInit(): void {
  }

}
